/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Documents_Satisfied_TitleInputs */

const en_case_documents_satisfied_title = /** @type {(inputs: Case_Documents_Satisfied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulfilled documents`)
};

const pt_br2_case_documents_satisfied_title = /** @type {(inputs: Case_Documents_Satisfied_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos atendidos`)
};

/**
* | output |
* | --- |
* | "Fulfilled documents" |
*
* @param {Case_Documents_Satisfied_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_documents_satisfied_title = /** @type {((inputs?: Case_Documents_Satisfied_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Documents_Satisfied_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_documents_satisfied_title(inputs)
	return pt_br2_case_documents_satisfied_title(inputs)
});